module.controller('uploadCntrl', function(esb, sharedService, services, $scope, $mdDialog, $window, theme, fileName, parentScope) {
  
  $scope.theme = theme.getTheme();
  var file = sharedService.getShared();
  var data = sharedService.getData();
  var type = file.type; 
  $scope.fileName = fileName;
 
  if (FileReader) {
    var fr = new FileReader();
    fr.onload = function () {
        if(type.includes("pdf")) {
          var typedarray = new Uint8Array(fr.result);
          pdfjsLib.getDocument(typedarray).promise.then(function (doc) {
            var pages = []; while (pages.length < doc.numPages) pages.push(pages.length + 1);

            return doc.getPage(1).then(makeThumb)
            .then(function (canvas) { 
          });
          }).catch(console.error);
        } else {
          document.getElementById("thumb").src = fr.result;
        }
        
    }
    $scope.pdf = false;
    if(type.includes("pdf")) {    
      $scope.pdf = true;
      fr.readAsArrayBuffer(file);
    } else {
      $scope.pdf = false;
      fr.readAsDataURL(file);
    }
  } 

  if (parentScope) {
      parentScope.progress = false; // this removes loading screen, which is activated before applying selected file to upload
  }

  $scope.closeDialog = function(){
    $mdDialog.cancel(); 
  }
 
  $scope.uploadFile = function(){
        $scope.progressCircular = "ok"; 
        var payload = new FormData(); 
        var format = type.split("/");
        var ext = format[1]
        if(ext.includes('spreadsheet')) ext = "xlsx"
        if(ext.includes('wordprocessing')) ext = "docx"
        payload.append('fileExtension', ext);
        payload.append("file", file);
        payload.append('type', data.id);
        payload.append('latitude', "1");
        payload.append('longitude', "1");
        services.user.userServices('bearer '+ $window.localStorage.getItem('access_token1')).uploadReceipt({}, payload, function(response, event){            
            $scope.progressCircular = undefined;
            if(response.data.url) {
              var ext = "png";  
              if(type.includes("pdf"))  ext = "pdf"
              if(type.includes("jpg"))  ext = "jpg"
              if(type.includes("png"))  ext = "png"
              if(type.includes("jpeg"))  ext = "jpg"
              
              if(type.includes('spreadsheet')) ext = "xlsx"
              if(type.includes('wordprocessing')) ext = "docx"
              var answer = {value: (esb + '/security' + response.data.url), extension: ext, id: data.id, skipId: null}             
              $scope.metadataObj = undefined;
              $mdDialog.hide(answer); 
            }
        });
   }
 


   function makeThumb(page) {
    var vp = page.getViewport(1.5);
    var canvas = document.createElement("CANVAS");
    canvas.width = vp.viewBox[2];
    canvas.height = vp.viewBox[3];
    //var scale = Math.min(canvas.width /vp.viewBox[2], canvas.height / vp.viewBox[3]);
    var context = canvas.getContext("2d")
    
    return page.render({canvasContext: canvas.getContext("2d"), viewport: page.getViewport(1.5, 10, 0, 0, true)}).promise.then(function () {
        var canvas1 = document.getElementById("thumb2");
        canvas1.width = canvas.width;
        canvas1.height = canvas.height;
        var context = canvas1.getContext("2d")         
        context.drawImage(canvas,0, 0);         
      return canvas1;
    });
  } 
});
